import { api } from "../util/api";

export function login(body: any) {
  return api.post("/login", body);
}

export function getUser(body: any) {
  return api.get("/api/user", body);
}

export function sendPoint(body: any) {
  return api.post("/api/user/point", body);
}
export function updateUser(body: any) {
  return api.patch("/api/user/", body);
}

export function updateUserLine(body: any) {
  return api.patch("/api/user/line", body);
}
export function sendUserLine(body: any) {
  return api.post("/api/user/line", body);
}
